import React, { useState, useEffect, useRef } from 'react'
import Modal from 'react-bootstrap/Modal'

import { PreOrderFetchAPI } from '../../../api/Paymentpost/PreOrder';
import { DeletedTempOrdersFetchAPI } from '../../../api/DeletedTemporalOrders';

import Swal from "sweetalert2";

import ErrorAlert from '../../Alerts/ErrorAlert';
import AlertSmall from '../../Alerts/AlertSmall';
import LoadingAlert from '../../Alerts/LoadingAlert';
import { GiPlayerTime } from 'react-icons/gi';
import ModalDetailPreOrder from '../ModalDetailPreOrder';
//Utils
import { buildCloudinaryImageUrl } from '../../../utils/CloudinaryImageUrl';
import { showApiError } from '../../../utils/ApiError';
import Empty from '../../utils/Empty';
import { RenderIf } from '../../utils/RenderIf';
//IMG

import imgPreOrder from '../../PaymentPost/img/logo_sp.png'
import defaultImage from '../../PaymentPost/img/logo_sp.png'
import refund from '../../PaymentPost/img/logo_sp.png'
import './styles.css'


function ModalDivisionByProduct({ getOrderNumber, orderNumberNow, order, setShowDivision, getAll, onPendingDelete, setShowPartsByProducts, showByProduct, setShowByProduct, division, codeParthner, resetInputs }) {
    //const [showByProduct, setShowByProduct] = useState(false);
    const [count, setCount] = useState(1)
    let index = 0;
    const [dataOrder, setDataOrder] = useState({});
    const [productChecked, setProductChecked] = useState([]);
    const [comboChecked, setComboChecked] = useState([]);
    const [productDivision, setProductDivision] = useState([])
    const [groups, setGroups] = useState([])
    const [combos, setCombos] = useState([])
    const [ordersCreated, setOrdersCreated] = useState("");
    const createdPreOrdersRef = useRef([]);
    const createdOrderCodesRef = useRef([]);

    const isPendingDeleteTimeout = (err) => {
        return err?.response?.status === 504 || err?.code === "ECONNABORTED";
    }

    const preserveKitchenStateForSplit = (items = []) => {
        return items.map((item) => {
            const wasAlreadySentToKitchen = item.kitchen_action === "send_to_kitchen" && item.isNewAdd !== true;
            return {
                ...item,
                kitchen_action: item.kitchen_action || "send_to_kitchen",
                isNewAdd: wasAlreadySentToKitchen ? false : item.isNewAdd,
                amount_to_impress: wasAlreadySentToKitchen ? 0 : Number(item.amount_to_impress ?? item.amount ?? 1),
            };
        });
    }

    //create preOrder
    const createPreOrder = async (products, combosnow, discount, subtotal, tax, total, productList, comboList, taxesArray
    ) => {
        let token = localStorage.getItem('x-access-machine-token');
        let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
        let machine = JSON.parse(localStorage.getItem('machine'))
        let user = JSON.parse(localStorage.getItem('user'));

        let newOrderNumber = await getOrderNumber(true);


        let json = {
            "transaction_code": newOrderNumber,
            "client_name": order.client_name + " " + (count + 1),
            "localizador": order.locator,
            "client_phone": order.client_phone,
            "ruc": order.client_ruc,
            "dv": order.client_dv,
            "id_Client": 0,
            "dgi_qr": "0",
            "Orden": preserveKitchenStateForSplit(products),
            "combos": preserveKitchenStateForSplit(combosnow),
            "Descuento": parseFloat(discount).toFixed(2),
            "Total": parseFloat(total).toFixed(2),
            "itbms": parseFloat(tax).toFixed(2),
            "taxes": taxesArray,
            "subtotal": parseFloat(subtotal).toFixed(2),
            "machine_id": machine.id,
            "branchoffice_id": branchoffice.id,
            "tipoOrden": order.order_type,
            "paymethod": 0,
            "is_discount_notification": false,
            "is_cupon": false,
            "is_devolution_notification": false,
            "is_pre_order": true, "user": {
                id: user.id,
                name: user.name,
                code: user.user_code
            }
        }

        if (order.table_name) {
            json.table_name = order?.table_name || null
            json.table_id = order?.table_id || null
        }

        if ((combosnow.length + products.length) > 0) {
            try {
                const response = await PreOrderFetchAPI.createPreOrder(json, token);
                if (response.data?.newTempOrder) {
                    createdPreOrdersRef.current = [...createdPreOrdersRef.current, response.data.newTempOrder];
                    createdOrderCodesRef.current = [...createdOrderCodesRef.current, response.data.newTempOrder.code];
                }
                //count = (count + 1)
                setCount(prev => prev + 1)
                let message = "Precuenta " + count + " creada con exito."
                let title = "Operacion exitosa."
                let icon = "success";

                groups.forEach((product, index) => {
                    document.getElementById(product.name + "group" + index).checked = false

                })

                combos.forEach((combo, index) => {
                    document.getElementById(combo.name + "combo" + index).checked = false
                })



                console.log(count);
                if (division > count) {

                    if ((productList.length + comboList.length) > 0) {
                        setGroups(productList);
                        setCombos(comboList)
                        setOrdersCreated(createdOrderCodesRef.current.join(" / "))
                        Swal.close();
                    } else {
                        message = "Precuenta " + count + " asignaste los todos los productos restantes, creada con exito."
                        setShowByProduct(false);
                        setShowDivision(false);
                        deletePreOrder(dataOrder.code, createdOrderCodesRef.current.join(" / "));
                        setCount(1)
                        resetInputs()
                    }

                    setProductChecked([]);
                    setComboChecked([])
                    //calculateInvoiceTotals(productChecked);
                } else {

                    setShowByProduct(false);
                    setShowDivision(false);
                    deletePreOrder(dataOrder.code, createdOrderCodesRef.current.join(" / "));
                    setCount(1)

                }

            } catch (err) {
                showApiError(err, {
                    title: "No se pudo crear la precuenta dividida",
                    message: "El servidor no pudo crear una de las precuentas separadas.",
                    context: `source_order=${order?.code || ""}`,
                }, ErrorAlert);
            }
        } else {
            ErrorAlert("", "No hay productos seleccionados para esta precuenta ", "error")
        }

    }

    //delete preorder
    const deletePreOrder = async (code, newOrderCode) => {
        LoadingAlert("Eliminando precuenta original", "Espere mientras se completa el borrado de la precuenta original...")
        let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
        let business = JSON.parse(localStorage.getItem('business'))
        let user = JSON.parse(localStorage.getItem('user'));
        let machine_token = localStorage.getItem('x-access-machine-token');

        let business_code = business.code
        let branch_code = branchoffice.code

        if (codeParthner != 0) {
            business_code = codeParthner.business_code
            branch_code = codeParthner.branchoffice_code
        }

        let jsonUpdate = {
            "order_code": code,
            "business_code": business_code,
            "branchoffice_code": branch_code,
            "status": 5,
            "deleted": true,
            "justification": "Precuenta separada por productos: codigo de precuenta eliminada " + code + ". Nuevas precuentas: " + newOrderCode,
            "user_id": user.id,
            "deleted_code": "DIVIDED_BILL"
        }
        try {
            try {
                //We save the preorder deletion audit, but the real delete must not depend on it.
                await DeletedTempOrdersFetchAPI.newDeletedTempOrder(jsonUpdate, machine_token);
            } catch (auditErr) {
                console.log("No se pudo registrar la eliminacion de la precuenta dividida", auditErr);
            }

            //We delete the preorder
            await PreOrderFetchAPI.deletePreOrder(jsonUpdate, machine_token)
            let message = "precuenta eliminada con exito."
            let title = "Precuenta eliminada"
            let icon = "success"

            console.log("precuenta original eliminada");
            Swal.close();
            //ErrorAlert(message, title, icon)
            AlertSmall("Precuenta dividida con exito", "success")
            getAll();
        } catch (err) {
            if (isPendingDeleteTimeout(err)) {
                console.log("El borrado de la precuenta original sigue en proceso", err);
                Swal.close();
                onPendingDelete?.(code, createdPreOrdersRef.current);
                await ErrorAlert("El borrado de la precuenta original sigue en proceso. Las nuevas precuentas ya fueron creadas; refrescaremos la lista para verificar el estado.", "Borrado en proceso", "info", 10000);
                getAll();
                return;
            }

            showApiError(err, {
                title: "No se pudo eliminar la precuenta original",
                message: "Esta precuenta pertenece a otra sucursal o no se pudo eliminar.",
                context: `order_code=${code || ""} new_orders=${newOrderCode || ""}`,
                icon: "warning",
            }, ErrorAlert);
        }
    }

    //filter checkbox in state true and save in state array
    const getChecked = (event) => {
        let dataProduct = JSON.parse(event.target.value)
        dataProduct.index = event.target.dataset.index;
        if (event.target.checked == true) {

            if (dataProduct.combo_id) {
                setComboChecked([...comboChecked, dataProduct])
            } else {
                setProductChecked([...productChecked, dataProduct]);
            }

        } else if (event.target.checked == false) {
            for (let i = 0; i < productChecked.length; i++) {
                if (productChecked[i].index == event.target.dataset.index) {
                    productChecked.splice(i, 1);

                }
            }

            for (let c = 0; c < comboChecked.length; c++) {
                if (comboChecked[c].index == event.target.dataset.index) {
                    comboChecked.splice(c, 1);
                }
            }
        }


    }

    const getPreOrderByid = async () => {
        let machine_token = localStorage.getItem('x-access-machine-token');
        try {
            const response = await PreOrderFetchAPI.getPreOrderById(order._id, machine_token);
            createdPreOrdersRef.current = [];
            createdOrderCodesRef.current = [];
            setDataOrder(response.data.pre_order)
            setGroups(order.groups)
            setCombos(order.combos)
        } catch (err) {
            console.log(err);
        }
    }



    const separateOrder = (products, combos, discount, subtotal, tax, total, productList, comboList, taxesArray) => {
        products.forEach(group => {
            group.DetalleSegmentos = group.segments
        });
        createPreOrder(products, combos, discount, subtotal, tax, total, productList, comboList, taxesArray)
    }

    const divisionProduct = () => {
        LoadingAlert("Dividiendo precuenta", "Espere mientras se crean las nuevas precuentas...")
        if (count <= 1) {
            createdPreOrdersRef.current = [];
            createdOrderCodesRef.current = [];
        }

        // Filtrar los productos que no han sido seleccionados
        const productList = groups.filter((group, index) => {
            return !productChecked.some(checked => checked.idPositionArrayNow === group.idPositionArrayNow);
        });

        // Filtrar los combos que no han sido seleccionados
        const comboList = combos.filter(combo => {
            return !comboChecked.some(checked => checked.idPositionArrayNow === combo.idPositionArrayNow);
        });

        if ((productChecked.length + comboChecked.length) > 0) {
            if (count == division) {
                if ((productList.length + comboList.length) > 0) {
                    ErrorAlert('', 'Esta es la ultima cuenta debe seleccionar los productos restantes', 'warning');
                } else {
                    calculateInvoiceTotals(productChecked, productList, comboChecked, comboList);
                }
            } else {
                calculateInvoiceTotals(productChecked, productList, comboChecked, comboList);
            }

        } else {
            if (count > 1) {
                calculateInvoiceTotals(productChecked, productList, comboChecked, comboList);
            } else {
                ErrorAlert("", 'No es posible separar esta precuenta', 'warning', 2000);
            }
        }


    }


    const calculateInvoiceTotals = (products, productList, combos, comboList) => {

        //For every new calculate we set the totals
        let taxesArray = [];
        let invoiceTotalDiscount = 0
        let invoiceSubtotal = 0
        let invoiceTotalItbms = 0
        let invoiceTotal = 0

        //if we dont we products we put the totals in 0 for default
        if ((products.length + combos.length) === 0) {
            //We calculate the totals of the invoice
        } else {
            //For every product we calculate

            combos.forEach((combo) => {
                byProductandCombo(combo)
            })

            products.forEach((group) => {
                byProductandCombo(group)
            })

            function byProductandCombo(item) {
                let product_info = item
                //Variables
                let total_product_price = 0;
                let total_product_itbms = 0;
                let product_total_discount = 0;
                //We set the total discount of the product
                product_total_discount = (product_info.unit_discount * product_info.amount);
                //We set the total of the product
                total_product_price = (product_info.amount * (product_info.price - product_info.unit_discount));


                //Calculate tax by group--------------------------------
                let taxesGroup = product_info.taxes;
                taxesGroup.forEach(tax => {

                    //calculate tax  value and add it to array
                    let valueTax = (product_info.amount * ((product_info.price - product_info.unit_discount) * tax.taxtValue));
                    tax.total = valueTax;
                    //Identifier tax of the group position
                    var index = taxesArray.findIndex(function (info, i) {
                        return info.tax_id === tax.tax_id
                    });

                    if (index < 0) {
                        let taxInfoNow = {
                            "dTasaITBMSValue": tax.dTasaITBMSValue,
                            "percentage": tax.percentage,
                            "tax": tax.tax,
                            "tax_id": tax.tax_id,
                            "taxtValue": tax.taxtValue,
                            "total": valueTax
                        }
                        taxesArray.push(taxInfoNow);
                    } else {
                        taxesArray[index].total = (taxesArray[index].total + valueTax)
                    }
                    total_product_itbms = (total_product_itbms + valueTax);

                });
                //-------------------------------------------------------


                //We set the itbms of the product
                //total_product_itbms = (product_info.amount * ((product_info.price - product_info.unit_discount) * product_info.taxtValue));

                //We calculate the totals of the invoice
                invoiceTotalDiscount = invoiceTotalDiscount + product_total_discount;
                invoiceSubtotal = invoiceSubtotal + total_product_price;
                invoiceTotalItbms = invoiceTotalItbms + total_product_itbms;
                invoiceTotal = invoiceTotal + total_product_price + total_product_itbms;
            }



            console.log("Descuento:" + invoiceTotalDiscount);
            console.log("SubTotal:" + invoiceSubtotal);
            console.log("Itbms:" + invoiceTotalItbms);
            console.log("Total:" + invoiceTotal);
            console.log(comboList);

        }

        separateOrder(products, combos, invoiceTotalDiscount, invoiceSubtotal, invoiceTotalItbms, invoiceTotal, productList, comboList, taxesArray);
    }

    const cardProduct = (product, index) => {
        return (<>


                <div className="sp-cp-wrap" key={index}>
                    <input
                        className="sp-cp__check"
                        type="checkbox"
                        value={JSON.stringify(product)}
                        data-index={index}
                        id={product.combo_id ? product.name + "combo" + index : product.name + "group" + index}
                        name="checked1"
                        onChange={(e) => (getChecked(e))}
                    />

                    <label
                        className="sp-cp"
                        htmlFor={product.combo_id ? product.name + "combo" + index : product.name + "group" + index}
                    >
                        <img
                            className="sp-cp__thumb"
                            src={buildCloudinaryImageUrl({ url: product.img, width: 300, quality: "auto", type: "image" }) || defaultImage}
                            loading="lazy"
                            alt={product.name}
                            width="50" height="50"
                        />

                        <div className="sp-cp__info">
                            <h6 className="sp-cp__name">{product.name}</h6>
                            <span className="sp-cp__price" translate="no">$ {product.price.toFixed(2)}</span>
                        </div>

                        <span className="sp-cp__tick" aria-hidden="true">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12" /></svg>
                        </span>
                    </label>
                </div>

         
        </>)
    }


    useEffect(() => {
        (async () => {
            getPreOrderByid()
        })();
    }, []);

    useEffect(() => {

    }, [groups]);


    return (
        <>

            <Modal
                show={showByProduct}
                fullscreen
                onHide={() => setShowByProduct(false)}
                aria-labelledby="example-custom-modal-styling-title"
                contentClassName="sp-dbp-content"
            >
                <Modal.Body className="sp-dbp">

                    {/* Header */}
                    <div className="sp-dbp__head">
                        <div className="sp-dbp__badge"><i className="uil uil-apps"></i></div>
                        <div className="sp-dbp__headinfo">
                            <h4 className="sp-dbp__title">Dividir por productos</h4>
                            <span className="sp-dbp__count">Cuenta <strong>{count}</strong> de {division}</span>
                        </div>
                        <button className="sp-dbp__x" type="button" aria-label="Cerrar" onClick={() => setShowByProduct(false)}>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
                        </button>
                    </div>

                    {/* Cuerpo */}
                    <div className="sp-dbp__body">
                        <div className="sp-dbp__detail">
                            <ModalDetailPreOrder orderData={order}></ModalDetailPreOrder>
                        </div>

                        <div className="sp-dbp__sectlabel">
                           Selecciona los productos de la cuenta {count}
                        </div>

                        <div className="sp-dbp__grid">
                            {groups.map((product, index) => (
                                cardProduct(product, index)
                            ))}
                            {combos.map((combo, index) => (
                                cardProduct(combo, index)
                            ))}
                        </div>
                    </div>

                    {/* Footer */}
                    <div className="sp-dbp__foot">
                        <RenderIf isTrue={count == 1}>
                            <button className="sp-dbp__btn sp-dbp__btn--cancel" onClick={() => (setProductChecked([]), setShowByProduct(false))}>Cancelar</button>
                        </RenderIf>
                        <button className="sp-dbp__btn sp-dbp__btn--primary" onClick={() => divisionProduct()}>Dividir</button>
                    </div>

                </Modal.Body>
            </Modal>
        </>
    )
}

export default ModalDivisionByProduct
